import { useState } from "react";
import * as styled from "./SelectDateTime.styled";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function SelectDateTime({ selectedDateTime, setSelectedDateTime }) {
  const [startDate, setStartDate] = useState(new Date());
  
  return (
    <styled.Wrapper>
      <styled.Label>Оберіть дату та час:</styled.Label>
      <DatePicker
        selected={startDate}
        onChange={(date) => {
          setStartDate(date);
          setSelectedDateTime({
            date: date.toISOString().split('T')[0], // Формат YYYY-MM-DD
            time: date.toTimeString().substring(0, 5) // Формат HH:MM
          });
        }}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={30}
        dateFormat="MMMM d, yyyy HH:mm"
        minDate={new Date()}
      />
    </styled.Wrapper>
  );
}

export default SelectDateTime;